export function IsFormulaNameReserved(formulaName, curDoc) {
  if (!curDoc) {
    return true;
  }
  try {
    const fieldID = curDoc.GetFieldIDIfNotReserved(formulaName);
    return fieldID === null;
  } catch (error) {
    console.error("Error validating formula name:", error);
    return true;
  }
}
